'use client';

import { BreadcrumbProps } from '@commerce-product-webcomponents/sdk';
import { Breakpoints, useBreakpoint, useTranslation } from '@nextgen-web-framework/all';
import styles from './ShopFinderPage.module.scss';
import Layout from 'app/components/Layout/Layout';
import ShopFinder from 'app/components/ShopFinder/ShopFinder';
import { BasePageProps } from 'types/common';
import withNextgenRoute from 'app/utils/withNextgenRoute';
import useLivePreview from 'live-preview/useLivePreview';

const ShopFinderPage = (props: BasePageProps) => {
  const translate = useTranslation();
  const viewPortType = useBreakpoint() as Breakpoints;
  const [pageData] = useLivePreview(props.data, props.data?.seo_config);
  const header = pageData?.layout?.header;
  const footer = pageData?.layout?.footer;
  const isDesktop =
    viewPortType === Breakpoints.LG || viewPortType === Breakpoints.XL || viewPortType === Breakpoints.MD;
  const crumbsData: BreadcrumbProps = {
    breadcrumbData: [],
  };
  crumbsData.breadcrumbData.push(
    {
      name: translate('web.bottomTabNavigation.home'),
      link: '/',
    },
    {
      name: translate('web.shopFinder'),
      link: '',
    },
  );

  return (
    <>
      <Layout
        hasTopMobileHeader={true}
        header={header}
        footer={footer}
        isStaticLocationSelector
        crumbsData={crumbsData}
        hideLocationSelector
        headerProps={{
          isStaticHeader: true,
          headerElement: (
            <div className={styles['heading-style']} data-testid="shop-finder-container">
              {translate('web.shopFinder')}
            </div>
          ),
          isBackNavigation: false,
        }}
      >
        <div className={styles['shop-finder-container']}>
          {isDesktop && (
            <div className={styles['heading-style']} data-testid="shop-finder-container">
              {translate('web.shopFinder')}
            </div>
          )}
          <div className={styles['shop-finder-layout']}>
            <ShopFinder />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default withNextgenRoute<BasePageProps>(ShopFinderPage);
